import React from 'react';
import { NavLink } from 'react-router-dom';

const Header = () => {
  return (
    <header>
      <div className="a1now-header">
        <div className="container">
          <div className="row j-c-between">
            <div className="col col-auto">
              <NavLink to="/" className="a1now-header__logo">
                <img
                  src="https://media.a1.bg/xploretv/uploads/2018/09/logo.png"
                  alt="A1 Xplore TV GO"
                />
              </NavLink>
            </div>
            <div className="col col-auto is-hidden-m">
              <nav className="a1now-header__mainnav a1now-mainnav">
                <ul id="menu-main-menu" className="a1now-mainnav__ul">
                  <li className="menu-item">
                    <NavLink to="/televiziia" className="nav-link">
                      ТВ пакети
                    </NavLink>
                  </li>
                  <li className="menu-item">
                    <a href="https://help.a1.bg/tv/xploretvgo" className="nav-link">
                      Помощ Xplore TV GO
                    </a>
                  </li>
                  <li className="menu-item">
                    <a href="https://new.a1xploretv.bg/" className="nav-link">
                      Вход
                    </a>
                  </li>
                  <li className="menu-item">
                    <NavLink to="/start" className="nav-link">
                      Регистрация
                    </NavLink>
                  </li>
                </ul>
                <div className="a1now-mainnav__indicator" />
              </nav>
            </div>

            <div className="col a-s-center j-c-end is-hidden is-visible-m">
              <NavLink to="#" className="a1now-mobileoverlay-trigger">
                <div className="a1now-mobileoverlay-trigger-inner" />
              </NavLink>
            </div>
          </div>
        </div>
      </div>

      <div className="a1now-mobileoverlay" aria-hidden="true">
        <button type="button" className="a1now-mobileoverlay__close">
          <span className="a1now-icon-cross" />
        </button>

        <div className="a1now-mobileoverlay__title">A1 Xplore TV GO</div>
        <nav className="a1now-mobileoverlay__mainnavmobile a1now-mainnavmobile">
          <ul id="menu-main-menu-mobile" className="a1now-mainnavmobile__ul">
            <li className="menu-item">
              <NavLink to="/televiziia" className="nav-link">
                ТВ пакети
              </NavLink>
            </li>
            <li className="menu-item">
              <a href="https://help.a1.bg/tv/xploretvgo" className="nav-link">
                Помощ Xplore TV GO
              </a>
            </li>
            <li className="menu-item">
              <a href="https://new.a1xploretv.bg/" className="nav-link">
                Вход
              </a>
            </li>
            <li className="menu-item">
              <NavLink to="/start" className="nav-link">
                Регистрация
              </NavLink>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;
